/** Shared background tint alpha for colored badges (role badges, matrix column badges). */
export const BADGE_BACKGROUND_ALPHA = 0.15;

/** Shared border tint alpha for colored badges. */
export const BADGE_BORDER_ALPHA = 0.3;

/**
 * Convert a hex color string to an rgba() CSS value.
 *
 * @param hex - A 6-digit hex color string (e.g., '#2662D9')
 * @param alpha - Opacity value between 0 and 1
 * @returns An rgba() CSS string (e.g., 'rgba(38, 98, 217, 0.15)')
 */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
